import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export function setupIGO() {
  const triggers = document.querySelectorAll('[data-igo-image]');

  if (triggers && triggers.length > 0) {
      Array.from(triggers).forEach(trigger => {
          trigger.addEventListener('click', event => {
              new IGO(trigger);
          });
      });
  }
}

const mainClass = 'image-gallery-overlay';

class IGO {
  /**
   * Creates new Image gallery overlay
   * @param {DOM element} triggerElement 
   */
  constructor(triggerElement) {
    this.parent = triggerElement.parentElement;
    this.igo = null;
    this.closeWord = 'Luk';
    this.isSingleImage = triggerElement.closest('[data-igo-gallery]') ? false : true;
    this.startingIndex = 0;
    this.galleryImages = [];
    this.swiper = null;
    
    if(!this.isSingleImage) {
      this.getStartIndex(triggerElement);
    }
    
    this.getGalleryImages(triggerElement);
    this.createOverlay();
  }
  
  /**
   * Get the index in the gallery of the image/trigger clicked
   * @paremt {DOM element} startIndexElement - The DOM element of the clicked item
   */
  getStartIndex(startIndexElement) {
    const imageArray = this.parent.children;
    this.startingIndex = Array.from(imageArray).indexOf(startIndexElement);
  }
  
  /**
   * Builds and array of objects with the images in the gallery.
   * As of right now (06/04/22) we store more data than needed, for future ideas
   * @param {DOM element} triggerElement
   */
  getGalleryImages(triggerElement) {
    if(this.isSingleImage) {
      this.galleryImages.push({
        title: triggerElement.getAttribute('title'),
        index: 0,
        thumb: triggerElement.getAttribute('src'),
        fullImage: triggerElement.getAttribute('data-igo-image')
      })
    } else {
      const allImages = this.parent.querySelectorAll('[data-igo-image]');
    
      Array.from(allImages).forEach(image => {

        const imageInfo = {
          title: image.getAttribute('title'),
          index: this.getImageIndex(image),
          thumb: image.getAttribute('src'),
          fullImage: image.getAttribute('data-igo-image')
        };

        this.galleryImages.push(imageInfo);
      });
    }
  }
  
  /**
    * Get the index of and image in its container
    * Used by the getGalleryImages methods
    */
  getImageIndex(image) {
    const imageContainer = image.parentElement;
    const imagesInContainer = imageContainer.children;
    
    return Array.from(imagesInContainer).indexOf(image);
  } 
  
  /**
    * Builds all the HTML needed for the overlay. Last it append it to the body element.
    */
  createOverlay() {
    const igoBackdrop = document.createElement('div');
    igoBackdrop.classList.add(mainClass + '__backdrop');
    igoBackdrop.addEventListener('click', (event) => {
      this.igo.remove();
    });
    
    const igoCloseBtn = document.createElement('button');
    igoCloseBtn.classList.add(mainClass + '__close-button');
    igoCloseBtn.innerText = this.closeWord;
    igoCloseBtn.addEventListener('click', (event) => {
      this.igo.remove();
    });
    
    const igoContent = document.createElement('div');
    igoContent.classList.add(mainClass + '__content');
    igoContent.appendChild(this.createGallery());
    igoContent.appendChild(igoCloseBtn);

    const igoContainer = document.createElement('div');
    igoContainer.classList.add(mainClass);
    igoContainer.appendChild(igoBackdrop);
    igoContainer.appendChild(igoContent);
    
    this.igo = igoContainer;

    document.body.appendChild(this.igo);
  }
  
  /**
   * Build the image specific HTMl for the overlay.
   * If more than one image it builds the correct markup for a swiper
   */
  createGallery() {
    if(this.galleryImages.length > 1) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('swiper-wrapper');
      
      Array.from(this.galleryImages).forEach(imageInfo => {
        const image = new Image();
        image.src = imageInfo.fullImage;
        image.alt = imageInfo.title;
        
        const item = document.createElement('div');
        item.classList.add(mainClass + '__content-item', 'swiper-slide');
        item.appendChild(image);
        
        wrapper.appendChild(item);
      });
      
      const prev = document.createElement('div');
      prev.classList.add(mainClass + '__button', mainClass + '__button--prev');
      
      const next = document.createElement('div');
      next.classList.add(mainClass + '__button', mainClass + '__button--next');
      
      const pagination = document.createElement('div');
      pagination.classList.add(mainClass + '__pagination');
      
      const swiperDOM = document.createElement('div');
      swiperDOM.classList.add('swiper');
      swiperDOM.appendChild(wrapper);
      swiperDOM.appendChild(prev);
      swiperDOM.appendChild(next);
      swiperDOM.appendChild(pagination);
      
      this.swiper = new Swiper(swiperDOM, {
        initialSlide: this.startingIndex,
        pagination: {
          el: pagination,
          type: 'progressbar',
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
      
      return swiperDOM;
      
    } else {
      const imageInfo = this.galleryImages[0];
      const image = new Image();
      image.src = imageInfo.fullImage;
      image.alt = imageInfo.title;
      
      const item = document.createElement('div');
      item.classList.add(mainClass + '__content-item', mainClass + '__content-item--single');
      item.appendChild(image);
      
      return item;
    }
  }
}